import {Pipe, PipeTransform} from '@angular/core';

declare var moment: any;

@Pipe({name: 'isoToDateUTC'})
export class ISOToDateUTCPipe implements PipeTransform {

    constructor() { }

    transform(value: string, args: string): string {
        let date;
        value = value.toString();

        date = moment.unix(Number.parseInt(value)).utc();
        if(date._d.getFullYear() > 3000) {
            date = moment.unix(Number.parseInt(value) / 1000).utc();
        }

        // let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        // let month =  (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        // let year = date.getFullYear();

        // const resultDate = day  + '-' + month + '-' + year;
        // const mode = args;
        // if(args == 'dateOnly')
        //     return resultDate;

        // let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        // let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        // let seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

        return date.format('DD-MM-YYYY, [at] HH:mm:ss') + ' (GMT)';
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/iso-to-date-utc.pipe.ts